var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.link ? 'router-link' : 'div',{tag:"component",staticClass:"table-field",attrs:{"to":_vm.link}},[_c('field',_vm._b({attrs:{"alt":{data: _vm.data, type: 'table'}},on:{"event":_vm.event}},'field',_vm.column,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }